import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "./AccountRefresh.css";
import { initStripeConnectOnboarding } from "Config/API/action";

export default function AccountRefresh() {
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState(
    "Regenerating your Stripe onboarding link..."
  );

  useEffect(() => {
    let cancelled = false;

    const regenerateOnboarding = async () => {
      const token = localStorage.getItem("token");
      const countryCode =
        sessionStorage.getItem("stripe_country_code") ||
        localStorage.getItem("stripe_country_code");

      if (!token || !countryCode) {
        if (!cancelled) {
          setStatus("error");
          setMessage(
            "Your onboarding session information is missing. Please start again from country selection."
          );
        }
        return;
      }

      try {
        const appOrigin = window.location.origin;
        const refreshUrl = `${appOrigin}/refresh`;
        const returnUrl = `${appOrigin}/return`;
        const res = await initStripeConnectOnboarding(
          token,
          countryCode,
          refreshUrl,
          returnUrl
        );

        if (!res?.status || !res?.data?.onboarding_url) {
          throw new Error(
            res?.message || "Unable to regenerate Stripe onboarding link."
          );
        }

        if (res?.data?.account_id) {
          sessionStorage.setItem("stripe_account_id", res.data.account_id);
          localStorage.setItem("stripe_account_id", res.data.account_id);
        }

        if (!cancelled) {
          setStatus("success");
          setMessage("Redirecting you back to Stripe onboarding...");
        }

        window.location.assign(res.data.onboarding_url);
      } catch (err) {
        if (!cancelled) {
          setStatus("error");
          setMessage(
            err?.response?.data?.message ||
              err?.response?.data?.error ||
              err?.message ||
              "Unable to regenerate Stripe onboarding link."
          );
        }
      }
    };

    regenerateOnboarding();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="account-refresh-page">
      <div className="account-refresh-overlay" />
      <div className="container account-refresh-container">
        <div className="account-refresh-card text-center">
          <div className="account-refresh-icon-wrapper" aria-hidden="true">
            <span className="account-refresh-icon">!</span>
          </div>

          <p className="account-refresh-badge">
            {status === "loading"
              ? "Refreshing Session"
              : status === "success"
                ? "Redirecting"
                : "Session Expired"}
          </p>
          <h1 className="account-refresh-title">
            {status === "loading"
              ? "Please wait..."
              : status === "success"
                ? "Redirecting to Stripe"
                : "Stripe Session Expired"}
          </h1>
          <p className="account-refresh-description">{message}</p>

          <div className="account-refresh-actions">
            {status === "error" ? (
              <Link to="/dashboard" className="account-refresh-primary-btn">
                Restart from dashboard
              </Link>
            ) : null}
            <Link to="/dashboard" className="account-refresh-secondary-btn">
              Back to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
